import { createContext, useContext, useState, useEffect } from 'react'

const CatalogContext = createContext()

export const useCatalogSettings = () => {
  const context = useContext(CatalogContext)
  if (!context) {
    throw new Error('useCatalogSettings must be used within a CatalogProvider')
  }
  return context
}

export const CatalogProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    show_product_description: true,
    show_product_price: true,
    show_product_availability: true,
    show_availability_filter: true
  })

  // Charger les paramètres depuis le localStorage au démarrage
  useEffect(() => {
    const savedSettings = localStorage.getItem('catalog_settings')
    if (savedSettings) {
      try {
        setSettings(JSON.parse(savedSettings))
      } catch (error) {
        console.error('Erreur lors du chargement des paramètres du catalogue:', error)
      }
    }
  }, [])

  // Sauvegarder les paramètres dans le localStorage quand ils changent
  const updateSettings = (newSettings) => {
    const updatedSettings = { ...settings, ...newSettings }
    setSettings(updatedSettings)
    localStorage.setItem('catalog_settings', JSON.stringify(updatedSettings))
  }

  return (
    <CatalogContext.Provider value={{ settings, updateSettings }}>
      {children}
    </CatalogContext.Provider>
  )
}
